<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.name" placeholder="用户昵称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchQuery()">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="用户昵称"
          prop="account">
        </el-table-column>
        <el-table-column
          label="支付渠道">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.source =='0'" type="text" >小程序</el-button>
            <el-button size="mini" v-if="scope.row.source =='1'" type="text" >微信H5</el-button>
            <el-button size="mini" v-if="scope.row.source =='2'" type="text" >外部h5</el-button>
            <el-button size="mini" v-if="scope.row.source =='3'" type="text" >iosH5</el-button>
            <el-button size="mini" v-if="scope.row.source =='4'" type="text" >安卓H5</el-button>
            <el-button size="mini" v-if="scope.row.source =='5'" type="text" >安卓app</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="支付方式">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.ment =='0'" type="text" >兑换卷会员<span style="margin-left:15px" @click="onshow(scope.row.id)">查看</span></el-button>
            <el-button size="mini" v-if="scope.row.ment =='-1'" type="text" >电子支付</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="分类">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.menmberNum =='0'" type="text" >普通用户</el-button>
            <el-button size="mini" v-if="scope.row.menmberNum =='1'" type="text" >VIP会员</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="付费金额"
          prop="payPrice">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="付费时间"
          prop="modifyTime">
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p style="text-align:center">该用户的兑换码编号</p>
      <p style="text-align:center" v-for="(item,index) in codedata" :key="index"> {{item}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
      </el-dialog>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getfinancialList,getCodeList } from "../api/api"
  export default {
    data () {
      return {
        value: '',
        filters: {
          name: ''
        },
        options:[{
          value: ' ',
          label: '全部',
        }, {
          value: '0',
          label: '小程序',
        }, {
          value: '1',
          label: '微信H5',
        }, {
          value: '2',
          label: '外部h5',
        }, {
          value: '3',
          label: 'iosH5',
        }, {
          value: '4',
          label: '安卓H5',
        }, {
          value: '5',
          label: '安卓app',
        }],
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        codedata:[],
        dialogVisible:false
      }
    },
    components: {
      headTop,
    },
    methods: {
      //时间戳转换
      formatDate: function (value) {
        var dateee = new Date(value.modifyTime).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.searchQuery()
      },
      searchQuery () {
        let params = {
          pageNum: this.currentPage,
          pageSize: this.limit,
          account:this.filters.name,
          source:this.value
        };
        getfinancialList(params).then(res => {
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error => {
          console.log(error);
        })
      },
      onshow(id){
        this.dialogVisible = true
        let params = {
          userId: id
        };
        getCodeList(params).then(res => {
          this.codedata = res
        }).catch(error => {
          console.log(error);
        })
      }
    },
    created (){
      this.searchQuery()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>




// WEBPACK FOOTER //
// src/page/financial.vue